import { enumIsfCodeStep } from '@app/modules/isf/enums/enumIsfCodeStep';

export const ISF_CBP_MESSAGES_MAP: { [key: string]: (params: string[]) => enumIsfCodeStep } = {
  INVALID_ISF_IMPORTER_QUALIFIER: (params: string[]) => enumIsfCodeStep.IM,
  ISF_IMPORTER_NUMBER_NOT_ON_FILE: (params: string[]) => enumIsfCodeStep.IM,
  BOND_TYPE_NOT_ALLOWED: (params: string[]) => enumIsfCodeStep.SHIP,
  BOND_ACTIVITY_CODE_NOT_ALLOWED: (params: string[]) => enumIsfCodeStep.SHIP,
  SURETY_CODE_NOT_ALLOWED: (params: string[]) => enumIsfCodeStep.SHIP,
  DUPLICATE_BILL_NUMBERS: (params: string[]) => enumIsfCodeStep.SHIP,
  INVALID_IMPORTER_IDENTIFIER_QUALIFIER: (params: string[]) => enumIsfCodeStep.IM,
  INVALID_CONSIGNEE_IDENTIFIER_QUALIFIER: (params: string[]) => enumIsfCodeStep.CN,
  HTS_CODE_NOT_ON_FILE: (params: string[]) => enumIsfCodeStep.HTS,
  CONTINUOUS_BOND_NOT_ON_FILE: (params: string[]) => enumIsfCodeStep.SHIP,
  CONTINUOUS_BOND_NOT_ACTIVE: (params: string[]) => enumIsfCodeStep.SHIP,
  SURETY_CODE_NOT_ON_FILE: (params: string[]) => enumIsfCodeStep.SHIP,
  SURETY_CODE_NOT_ACTIVE: (params: string[]) => enumIsfCodeStep.SHIP,
  INVALID_ESTIMATED_UOM: (params: string[]) => enumIsfCodeStep.SHIP,
  INVALID_ESTIMATED_WEIGHT_QUALIFIER: (params: string[]) => enumIsfCodeStep.SHIP,
  BILL_NOT_UNIQUE: (params: string[]) => enumIsfCodeStep.SHIP,
  CARRIER_NOT_FOUND: (params: string[]) => enumIsfCodeStep.SHIP,
};
